export default "__VITE_PUBLIC_ASSET__861392cf__"